import {
    useGetDomainConfigQuery,
    useGetPublicDomainConfigQuery,
} from "@callveriq/redux/services/domain/domain.service";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import { Button, Typography } from "@mui/material";
import { PropsWithChildren, useEffect } from "react";
import { handleVersionChange } from "@callveriq/utils/helper/common.helper";
import Error500State from "./Error500State";
import useAuth from "@callveriq/hooks/useAuth";

export default function VersionApiLoader({ children }: PropsWithChildren) {
    const { data } = useGetPublicDomainConfigQuery();
    const { isAuthenticated } = useAuth();
    const { isLoading, error } = useGetDomainConfigQuery(undefined, {
        skip: !window.localStorage.getItem("authTokens"),
    });
    useEffect(() => {
        //Support for legacy code
        if (data) {
            const av = localStorage.getItem("av");
            if (parseInt(av || "0") !== data.version) {
                handleVersionChange();
            }
            localStorage.setItem("av", String(data.version));
        }
    }, [data]);

    if (isLoading && !error && isAuthenticated)
        return (
            <div className="w-full h-full flex flex-col justify-center items-center gap-5">
                <SystemUpdateAltIcon
                    sx={{
                        transform: "scale(3)",
                        color: "primary.main",
                    }}
                />
                <Typography variant="h6">Checking for updates...</Typography>
            </div>
        );

    if (error && isAuthenticated) {
        return (
            <Error500State
                ButtonComponent={
                    <Button
                        variant="global"
                        onClick={() => window.location.reload()}
                    >
                        Refresh
                    </Button>
                }
            />
        );
    }

    return <>{children}</>;
}
